import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const subscriptionRoutes: RouteObject[] = [
  {
    path: 'subscription',
    lazy: page('MySubscriptionPage'),
    handle: { title: '구독', yearIndependent: true, feature: 'SUBSCRIPTION' } satisfies RouteHandle,
  },
  {
    path: 'subscription/checkout',
    lazy: page('CheckoutPage'),
    handle: { title: '구독 결제', yearIndependent: true, feature: 'BILLING' } satisfies RouteHandle,
  },
  {
    path: 'subscription/billing-callback',
    lazy: page('BillingCallbackPage'),
    handle: { title: '결제 처리', yearIndependent: true, feature: 'BILLING' } satisfies RouteHandle,
  },
];
